module.exports = __webpack_public_path__ + "static/media/medi_learning_logo.5f746a8a.png";